"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var NpsThankYou_1 = require("../Nps/NpsThankYou");
var YotpoReviewFormOnly = function (_a) {
    var product = _a.product;
    var nonAlphabeticalRegex = /[^a-z]+/gi;
    var productTitleWords = product.title.split(nonAlphabeticalRegex);
    var productName = productTitleWords.slice(0, -1).join(' ');
    var productType = productTitleWords[productTitleWords.length - 1];
    //set up local state to control user flow
    var _b = (0, hooks_1.useState)(false), end = _b[0], setEnd = _b[1];
    window.addEventListener('formSubmitted', function () {
        setEnd(true);
    });
    (0, hooks_1.useEffect)(function () {
        var _a;
        // Reinitialize yotpo widget in case yotpo object is not loaded yet when the preact gets loaded
        // event.target is the window object
        // Event listener is of type MessageEvent but at compile time it cant tell
        // that theres a yotpo object added to it after runtime
        var loadYotpo = function (event) {
            if (typeof event.target.yotpo !== 'undefined') {
                window.removeEventListener('message', loadYotpo);
                event.target.yotpo.initWidgets();
            }
        };
        window.addEventListener('message', loadYotpo);
        // Listen to change for when yotpo thank you module appears
        var targetNode = document.querySelector('.yotpo-custom-form');
        var config = { attributes: true, childList: true, subtree: true };
        var callback = function (mutationList, observer) {
            var _a, _b;
            for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
                var mutation = mutationList_1[_i];
                // Trigger only if yotpo form is submitted successfully
                if (mutation.target.contains(document.querySelector('.yotpo-new-review-btn'))) {
                    if (document.querySelector('.yotpo-new-review-btn')) {
                        document.querySelector('.yotpo-new-review-btn').click();
                        (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.removeAttribute('style');
                        if (!document.querySelector('.yotpo-review-form')) {
                            window.addEventListener('load', function () {
                                var _a;
                                document.querySelector('.yotpo-new-review-btn').click();
                                (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.removeAttribute('style');
                            });
                        }
                    }
                }
                if (mutation.target.contains(document.querySelector('.yotpo-new-review-submit'))) {
                    (_b = document.querySelector('.yotpo-new-review-submit')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () {
                        var _a;
                        if (document.querySelectorAll('.yotpo-star-rating-error, .yotpo-new-input-validation')
                            .length == 0) {
                            setEnd(true);
                            (_a = document.querySelector('.yotpo-reviews-main-widget')) === null || _a === void 0 ? void 0 : _a.classList.add('hide');
                            window.dispatchEvent(new Event('formSubmitted'));
                        }
                    });
                    observer.disconnect();
                }
            }
        };
        var observer = new MutationObserver(callback);
        if (targetNode) {
            if ((_a = window.yotpoWidgetsContainer) === null || _a === void 0 ? void 0 : _a.initWidgets) {
                // Reload Yotpo widget
                window.yotpoWidgetsContainer.initWidgets();
            }
            observer.observe(targetNode, config);
        }
    }, []);
    return ((0, preact_1.h)(preact_1.Fragment, null, end ? ((0, preact_1.h)(NpsThankYou_1.default, null)) : ((0, preact_1.h)("div", { class: "yotpo-custom-form" },
        (0, preact_1.h)("div", { class: "yotpo-review-yotpo" },
            (0, preact_1.h)("div", { class: "product-title" },
                productName,
                " ",
                (0, preact_1.h)("span", { class: "product-title--serif" }, productType)),
            (0, preact_1.h)("img", { class: "product-image", src: product.featured_image, alt: product.title, width: 300, height: 300 })),
        (0, preact_1.h)("div", { class: "yotpo-widget-instance", "data-yotpo-instance-id": "481842", "data-yotpo-product-id": product.id, "data-yotpo-name": product.title, "data-yotpo-url": product.url })))));
};
exports.default = YotpoReviewFormOnly;
